import { autoinject, observable } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { validateEmail } from 'app/shared/lib/validation/validation-utilities';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssTextPage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected iconOptions: Array<string> = ['ui:icons.alert', 'ui:icons.assessment', 'ui:icons.city'];
    protected typeOptions: Array<string> = ['text', 'password', 'number', 'email'];
    protected id: guid = guid();

    protected validateEmail = validateEmail;

    ////****************** Lifecycle events (in order of execution) *****************////

    constructor(...rest: any[]) {
        super(...rest);
    }

    ////****************** Example 1 ********************************************////

    ////****************** Example 2 ********************************************////

    protected ex2MaxLength?: number | null = 10;

    ////****************** Example 3 ********************************************////

    ////****************** Example 4 ********************************************////

    protected ex4Label: string | null = 'Select a Value';
    protected ex4OverrideAriaLabel: string | null = 'Aria LabelledBy Override';
    protected ex4Type: string | null = this.typeOptions[0];
    protected ex4AccessKey: string | null = '';
    protected ex4ArialabelValue: string | null = 'Select a Value';

    ////****************** Example 5 ********************************************////
    protected ex5HelperSlotText: string | null = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam non ligula suscipit, accumsan nulla ac, rhoncus nisi.';
}
